import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import MicOutlinedIcon from "@mui/icons-material/MicOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import { PostType } from "./feedApi";

export const AVAILABLE_POST_TYPES = [
  PostType.IDEA,
  PostType.ACTION_LEGISLATION,
  PostType.QUESTION,
  PostType.POLICY_CREATED,
  PostType.RECENT_WIN,
];

export const POST_TYPES_WITH_EXTERNAL_LINK = [
  PostType.POLICY_CREATED,
  PostType.RECENT_WIN,
];

export function postTypeSupportsExternalLink(postType) {
  return POST_TYPES_WITH_EXTERNAL_LINK.includes(postType);
}

export function getExternalLinkHelperText(postType) {
  if (postType === PostType.POLICY_CREATED) {
    return "Link to official legislation or policy documents.";
  }
  if (postType === PostType.RECENT_WIN) {
    return "Link to news coverage or official announcements.";
  }
  return "Add a link to support your post.";
}

export const POST_TYPE_LABELS = {
  [PostType.IDEA]: "Share an Idea",
  [PostType.ACTION_LEGISLATION]: "Share an Action",
  [PostType.ACTION_TOWN_HALL]: "Attended Town Hall",
  [PostType.QUESTION]: "Ask a Question",
  [PostType.POLL]: "Create a Poll",
  [PostType.POLICY_CREATED]: "Share a Policy",
  [PostType.RECENT_WIN]: "Recent Win",
};

/** Label above the create-post intent tag picker. */
export const POST_TYPE_PICKER_LABEL =
  "Tag your post to facilitate direction and build momentum.";

/** Short labels for the create-post type tile grid. */
export const POST_TYPE_TILE_LABELS = {
  [PostType.IDEA]: "Idea",
  [PostType.ACTION_LEGISLATION]: "Action",
  [PostType.ACTION_TOWN_HALL]: "Town Hall",
  [PostType.QUESTION]: "Question",
  [PostType.POLL]: "Poll",
  [PostType.POLICY_CREATED]: "Policy",
  [PostType.RECENT_WIN]: "Recent Win",
};

/** Labels for feed filter dropdowns. */
export const POST_TYPE_FILTER_LABELS = {
  [PostType.POLICY_CREATED]: "Policy",
  [PostType.RECENT_WIN]: "Recent Win",
};

export const POST_TYPE_DESCRIPTIONS = {
  [PostType.IDEA]: "Propose an improvement, policy change, or community project.",
  [PostType.ACTION_LEGISLATION]: "Invite others to act, volunteer, attend, call, or email.",
  [PostType.ACTION_TOWN_HALL]: "Share what event you attended and what you learned.",
  [PostType.QUESTION]: "Ask your community for help or perspectives on civic issues.",
  [PostType.POLL]: "Ask a question and let your community vote on options.",
  [PostType.POLICY_CREATED]:
    "Share a policy or piece of legislation you've drafted, proposed, or helped pass.",
  [PostType.RECENT_WIN]:
    "Celebrate a civic accomplishment that moved your community forward.",
};

export const POST_TYPE_ICONS = {
  [PostType.IDEA]: <LightbulbOutlinedIcon />,
  [PostType.ACTION_LEGISLATION]: <CampaignOutlinedIcon />,
  [PostType.ACTION_TOWN_HALL]: <MicOutlinedIcon />,
  [PostType.QUESTION]: <HelpOutlineOutlinedIcon />,
  [PostType.POLL]: <PollOutlinedIcon />,
  [PostType.POLICY_CREATED]: <DescriptionOutlinedIcon />,
  [PostType.RECENT_WIN]: <EmojiEventsOutlinedIcon />,
};

export function getPostPlaceholder(postType) {
  switch (postType) {
    case PostType.IDEA:
      return "What's the problem you're seeing? What solution are you proposing?";
    case PostType.ACTION_TOWN_HALL:
      return "Share your experience at the town hall. What did you learn?";
    case PostType.QUESTION:
      return "What civic question or challenge do you need help with?";
    case PostType.ACTION_LEGISLATION:
      return "What action did you take and why? How did it go?";
    case PostType.POLL:
      return "What question do you want your community to weigh in on?";
    case PostType.POLICY_CREATED:
      return "What policy are you sharing, and why does it matter to your community?";
    case PostType.RECENT_WIN:
      return "What did you accomplish, and how did it help your community?";
    default:
      return "What's on your mind? Tell the community your story, idea, or experience.";
  }
}
